import { experimentalStyled } from '@material-ui/core/styles';


const YamanairLogo = (props) => (
  <img src="/static/YamanairCreative_Logo.png" width={props.width} />
);

export default YamanairLogo;
